<template>
    <div>
        <base-button
            @click="show_modal = true"
            icon="fas fa-plus"
            class="is-link is-outlined create-column"
            text="Create List"/>

        <base-modal :visible="show_modal" @close="show_modal = false" title="Create new column">
            <base-backend-errors :data="create.error"/>
            <column-form :loading="create.loading" @submit="submit" @cancel="show_modal = false"/>
        </base-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ColumnForm from './ColumnForm.vue';

export default {
    name: 'ColumnCreate',
    components: { ColumnForm },
    props: ['space', 'flow'],
    computed: mapState('columns', ['create']),
    data() {
        return { show_modal: false };
    },
    methods: {
        submit(data) {
            this.$store.dispatch('columns/create', {
                space_id: this.space.id,
                flow_id: this.flow.id,
                data,
            }).then(() => {
                this.$store.dispatch('columns/list', {
                    space_id: this.space.id,
                    flow_id: this.flow.id,
                });
                this.show_modal = false;
            });
        },
    },
};
</script>

<style scoped>
    .create-column {
        float: right;
        margin-right: 1rem;
    }
</style>
